import { render } from "./adbarchart.vue?vue&type=template&id=20c6c571&scoped=true"
import script from "./adbarchart.vue?vue&type=script&lang=js"
export * from "./adbarchart.vue?vue&type=script&lang=js"

import "./adbarchart.vue?vue&type=style&index=0&id=20c6c571&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20c6c571"]])

export default __exports__